<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] {{ $t('company') }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <!-- <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED)"/> -->
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Code" class="col-4">{{ $t('code') }}<span style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                    <InputText name="Code" v-model="header.Code" type="text" :placeholder="$t('code')"
                                        v-if="header" :class="{ 'p-invalid': submitted && !header.Code }"
                                        :disabled="mode != this.$FORM_MODE_CREATE"
                                        :readonly="mode != this.$FORM_MODE_CREATE" />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Code && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('code')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Description" class="col-4">{{ $t('company_name') }}<span
                                        style="color: red;">*</span></label>
                                <div class="col-8 md-8">
                                    <InputText name="Description" v-model="header.Description" required="true" type="text"
                                        :placeholder="$t('company_name')" v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.Description }"
                                        :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || (header && header.Status == this.$APPROVAL_STATUS.APPROVED)" />
                                    <Skeleton v-else-if="!header" />
                                    <small
                                        v-if="header && !header.Description && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('company_name')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid" v-if="mode != this.$FORM_MODE_CREATE">
                                <label for="Active" class="col-4">{{ $t('active') }}</label>
                                <div class="col-8 md-8">
                                    <Checkbox name="Active" v-model="header.Active" :binary="true" v-if="header"
                                        :disabled="true"
                                        />
                                    <Skeleton v-else-if="!header" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Active_SAP" class="col-4">{{ $t('Active_SAP') }}</label>
                                <div class="col-8 md-8">
                                    <Checkbox name="Active_SAP" v-model="header.Active_SAP" :binary="true" v-if="header"
                                        :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT)"
                                        />
                                    <Skeleton v-else-if="!header" />
                                </div>
                            </div>
                        </div>

                        <div class="col-6">
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-8 md-8">
                                <InputText name="Employee_Number" v-model="header.Status" type="text" :placeholder="$t('status')" 
                                v-if="header" :disabled="true" v-on:blur="onBlur()"/>
                            </FormField>

                            <FormField :labelName="$t('reason')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-8 md-8" v-if="header && (header.Status == this.$APPROVAL_STATUS.APPROVED || header.Reason != null)">
                                <InputText name="Reason" v-model="header.Reason" type="text" :placeholder="$t('reason')" 
                                v-if="header" :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" v-on:blur="onBlur()"/>
                                <small v-if="header && !header.Reason && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                </small>
                            </FormField>
                        </div>
                        <div class="col-6">
                                <DataTable v-if="header" :loading="!header" :value="header.Details ? header.Details : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetail()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetail(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Area" :header="$t('area')" Key="Area">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('area')" @change="onCellEditComplete(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div class="col-6">
                                <DataTable v-if="header" :loading="!header" :value="header.Locations ? header.Locations : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetailLoction()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetailLocation(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <!-- style="width: 150px;" -->
                                <Column field="Location_Id" :header="$t('location')" key="Location_Id">
                                    <template #body="slotProps">
                                        <CustomSelect
                                            v-model="slotProps.data[slotProps.column.props.field]" 
                                            :url="$API_URL + 'list/location_id'"
                                            :minLength="0"
                                            :params="{ }" 
                                            :filter="true"
                                            v-show="slotProps.data.mode != 'Delete'" 
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            @change="onCellEditCompleteLocation(slotProps)"
                                            />
                                    </template>  
                                </Column>

                            </DataTable>
                        </div>

                        <div class="col-6">
                                <DataTable v-if="header" :loading="!header" :value="header.DetailsName ? header.DetailsName : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetailName()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetailName(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>

                                <Column field="Name" :header="$t('Name_Comp')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <Textarea 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('Name')" @change="onCellEditCompleteName(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>

                                    
                                <Column field="Valid_Date" :header="$t('Valid_From')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <DatePicker name="Valid_Date" v-model="slotProps.data[slotProps.column.props.field]"
                                            :placeholder="$t('Valid_From')" @date-select="onCellEditCompleteName(slotProps);" @change="onCellEditCompleteName(slotProps);"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'"/>
                                            <!-- onSelectDate2($event,slotProps.data) -->
                                        </div>
                                    </template>
                                </Column>
                                

                            </DataTable>
                        </div>

                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>  
                        
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
export default {
    name: "Editor",
    data() {
        return {
            indexName: "CompanyIndex",
            url: this.$API_URL + "company/",
            header: null,
            detail: null,
            location : null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataChangesLog:this.$dataChangesLogMasterData,
            detailLog : null,
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Name" },
                { field: "Level", header: "Level" },
                { field: "Validity", header: "Validity" },
                { field: "Status", header: "Status" }
            ],
            detailname : null,
        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.location = response.data.data.location;
                    self.detailname = response.data.data.detailName;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.detailLog = response.data.data.header.DetailLog;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    if(self.header.Status == this.$APPROVAL_STATUS.APPROVED) self.header.Reason = null;
                })
                .catch(function (error) {
                    alert(error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if(self.header.mode == self.$FORM_MODE_CREATE || self.header.mode == self.$FORM_MODE_DRAFT)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Company " + self.header.Code + " has been Create successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_EDIT || self.header.mode == self.$FORM_MODE_DRAFT_EDIT)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Company " + self.header.Code + " has been Edit successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_DELETE)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Company " + self.header.Code + " has been Delete successfully", life: 3000 } });
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/Company/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            var self = this;
            //|| !this.header.Cost_Center
            if (!this.header.Description || !this.header.Code || (this.header.Status == this.$APPROVAL_STATUS.APPROVED && !this.header.Reason)) {
                return;
            }
            
            if(this.header.Details.length == 0){
                self.showError("Error", "Must have one detail")
                return;
            }   

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            var self = this;
            //|| !this.header.Cost_Center
            if (!this.header.Description || !this.header.Code) {
                return;
            }
            if(this.header.Details.length == 0){
                self.showError("Error", "Must have one detail")
                return;
            }   

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        addDetailLoction() {
            var newDetail = this.location;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Locations.push(det);
        },
        deleteDetailLocation(event) {
            if (event) {
                var detail = this.header.Locations[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Locations.splice(this.header.Locations.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteLocation(event) {
            this.editDetailLocation(event.index);
        },
        editDetailLocation(index) {
            if (this.header && this.header.Locations) {
                let mode = this.header.Locations[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Locations[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        
        addDetailName() {
            var newDetail = this.detailname;
            newDetail.mode = this.$FORM_MODE_CREATE;
            newDetail.Valid_Date = null;
            var det = { ...newDetail };

            this.header.DetailsName.push(det);
        },
        deleteDetailName(event) {
            if (event) {
                var detail = this.header.DetailsName[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.DetailsName.splice(this.header.DetailsName.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteName(event) {
            this.editDetailName(event.index);
        },
        editDetailName(index) {
            if (this.header && this.header.DetailsName) {
                let mode = this.header.DetailsName[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.DetailsName[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    }
}
</script>